export default {
  blank: () => import("/app/cms_public/layouts/blank.vue"),
  default: () => import("/app/cms_public/layouts/default.vue"),
  login: () => import("/app/cms_public/layouts/login.vue")
}